import aboutImg from "../assets/images/4.jpg";

const About = () => {
  return (
    <section
      id="about"
      className="py-20 px-4 md:px-6 lg:px-8 bg-secondary text-secondary-foreground"
    >
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 mb-8 md:mb-0">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">What We Do</h2>
            <p className="text-lg md:text-xl mb-4">
              We are a group of passionate engineers from Silicon Valley on a
              mission to solve the senior dating problem.
            </p>
            <p className="text-lg md:text-xl mb-4">
              With our combined expertise in technology and a deep understanding
              of the unique needs of seniors, we aim to create products that
              bring joy, companionship, and love to the golden years.
            </p>
            <p className="text-lg md:text-xl">
              Our platform is designed with simplicity and safety in mind,
              ensuring that our users can easily connect with like-minded
              individuals and potentially find their perfect match.
            </p>
          </div>
          <div className="md:w-1/2 md:pl-8">
            <img
              src={aboutImg}
              alt="Our team of engineers"
              width={400}
              height={300}
              className="rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
